import React from "react";
import PropTypes from "prop-types";

const Button = ({ color, text, onClick, className, disabled }) => {
  const baseStyles = {
    color: "white",
    padding: "0.5rem 1rem",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "opacity 0.3s ease",
    whiteSpace: "nowrap",
    backgroundColor: color,
    opacity: disabled ? 0.7 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
  };

  return (
    <button
      className={`button ${className}`}
      style={baseStyles}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

Button.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  color: "#006d7d",
  className: "",
  disabled: false,
};

export default Button;